import * as ambassadorWixEmailMarketingV1Campaign from './email-marketing-v1-campaign-campaigns.http.js';
import * as ambassadorWixEmailMarketingV1CampaignTypes from './email-marketing-v1-campaign-campaigns.types.js';
import * as ambassadorWixEmailMarketingV1CampaignUniversalTypes from './email-marketing-v1-campaign-campaigns.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getCampaign(): __PublicMethodMetaInfo<
  'GET',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.GetCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.GetCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.GetCampaignResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.GetCampaignResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions = ambassadorWixEmailMarketingV1Campaign.get(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/campaigns/{campaignId}',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCampaigns(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListCampaignsRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ListCampaignsRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListCampaignsResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ListCampaignsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEmailMarketingV1Campaign.list(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/campaigns',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishCampaign(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.PublishCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.PublishCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.PublishCampaignResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.PublishCampaignResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.publish(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/publish',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendTest(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.SendTestRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.SendTestRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.SendTestResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.SendTestResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.sendTest(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/test',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function pauseScheduling(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.PauseSchedulingRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.PauseSchedulingRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.PauseSchedulingResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.PauseSchedulingResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.pauseScheduling(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/pause-scheduling',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reschedule(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.RescheduleRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.RescheduleRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.RescheduleResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.RescheduleResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.reschedule(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/reschedule',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCampaign(): __PublicMethodMetaInfo<
  'DELETE',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.DeleteCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.DeleteCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.DeleteCampaignResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.DeleteCampaignResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign._delete(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/campaigns/{campaignId}',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reuseCampaign(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ReuseCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ReuseCampaignRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ReuseCampaignResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ReuseCampaignResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.reuse(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/reuse',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAudience(): __PublicMethodMetaInfo<
  'POST',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.GetAudienceRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.GetAudienceRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.GetAudienceResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.GetAudienceResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.getAudience(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaigns/{campaignId}/audience',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function identifySenderAddress(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.IdentifySenderAddressRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.IdentifySenderAddressRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.IdentifySenderAddressResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.IdentifySenderAddressResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.identifySenderAddress(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/identify-sender-address',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function validateLink(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ValidateLinkRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ValidateLinkRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ValidateLinkResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ValidateLinkResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.validateLink(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaign-validation/validate-link',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function validateHtmlLinks(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ValidateHtmlLinksRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ValidateHtmlLinksRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ValidateHtmlLinksResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ValidateHtmlLinksResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.validateHtmlLinks(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/campaign-validation/validate-html-links',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listStatistics(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListStatisticsRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ListStatisticsRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListStatisticsResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ListStatisticsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.listStatistics(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/campaigns/statistics',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listRecipients(): __PublicMethodMetaInfo<
  'GET',
  { campaignId: string },
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListRecipientsRequest,
  ambassadorWixEmailMarketingV1CampaignTypes.ListRecipientsRequest,
  ambassadorWixEmailMarketingV1CampaignUniversalTypes.ListRecipientsResponse,
  ambassadorWixEmailMarketingV1CampaignTypes.ListRecipientsResponse
> {
  const payload = { campaignId: ':campaignId' } as any;

  const getRequestOptions =
    ambassadorWixEmailMarketingV1Campaign.listRecipients(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/campaigns/{campaignId}/statistics/recipients',
    pathParams: { campaignId: 'campaignId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Campaign as CampaignOriginal,
  CampaignEditorTypeEnum as CampaignEditorTypeEnumOriginal,
  CampaignEditorTypeEnumWithLiterals as CampaignEditorTypeEnumWithLiteralsOriginal,
  CampaignStatusEnum as CampaignStatusEnumOriginal,
  CampaignStatusEnumWithLiterals as CampaignStatusEnumWithLiteralsOriginal,
  CampaignVisibilityStatusEnum as CampaignVisibilityStatusEnumOriginal,
  CampaignVisibilityStatusEnumWithLiterals as CampaignVisibilityStatusEnumWithLiteralsOriginal,
  Enum as EnumOriginal,
  EnumWithLiterals as EnumWithLiteralsOriginal,
  PublishingData as PublishingDataOriginal,
  CampaignStatistics as CampaignStatisticsOriginal,
  LandingPageStatistics as LandingPageStatisticsOriginal,
  DistributionStatistics as DistributionStatisticsOriginal,
  TotalStatistics as TotalStatisticsOriginal,
  RejectionData as RejectionDataOriginal,
  RejectionReasonEnum as RejectionReasonEnumOriginal,
  RejectionReasonEnumWithLiterals as RejectionReasonEnumWithLiteralsOriginal,
  CampaignSendingStateEnum as CampaignSendingStateEnumOriginal,
  CampaignSendingStateEnumWithLiterals as CampaignSendingStateEnumWithLiteralsOriginal,
  CampaignTypeEnum as CampaignTypeEnumOriginal,
  CampaignTypeEnumWithLiterals as CampaignTypeEnumWithLiteralsOriginal,
  GetPlaceholderKeysRequest as GetPlaceholderKeysRequestOriginal,
  GetPlaceholderKeysResponse as GetPlaceholderKeysResponseOriginal,
  GetDefaultComponentsRequest as GetDefaultComponentsRequestOriginal,
  GetDefaultComponentsResponse as GetDefaultComponentsResponseOriginal,
  GetCampaignRequest as GetCampaignRequestOriginal,
  GetCampaignResponse as GetCampaignResponseOriginal,
  ListCampaignsRequest as ListCampaignsRequestOriginal,
  Paging as PagingOriginal,
  CampaignEditorType as CampaignEditorTypeOriginal,
  ListCampaignsResponse as ListCampaignsResponseOriginal,
  CountCampaignsRequest as CountCampaignsRequestOriginal,
  CountCampaignsResponse as CountCampaignsResponseOriginal,
  CreateFromTemplateRequest as CreateFromTemplateRequestOriginal,
  CreateFromTemplateResponse as CreateFromTemplateResponseOriginal,
  CreateUserTemplateRequest as CreateUserTemplateRequestOriginal,
  CreateUserTemplateResponse as CreateUserTemplateResponseOriginal,
  CreateFromUserTemplateRequest as CreateFromUserTemplateRequestOriginal,
  CreateFromUserTemplateResponse as CreateFromUserTemplateResponseOriginal,
  PublishCampaignRequest as PublishCampaignRequestOriginal,
  EmailDistributionOptions as EmailDistributionOptionsOriginal,
  PublishCampaignResponse as PublishCampaignResponseOriginal,
  Rejected as RejectedOriginal,
  Published as PublishedOriginal,
  Terminated as TerminatedOriginal,
  Distributed as DistributedOriginal,
  EmailActivityUpdated as EmailActivityUpdatedOriginal,
  EmailActivityUpdatedEventTypeOneOf as EmailActivityUpdatedEventTypeOneOfOriginal,
  ActivityType as ActivityTypeOriginal,
  ActivityTypeWithLiterals as ActivityTypeWithLiteralsOriginal,
  Click as ClickOriginal,
  Open as OpenOriginal,
  SoftBounce as SoftBounceOriginal,
  HardBounce as HardBounceOriginal,
  Scheduled as ScheduledOriginal,
  SendTestRequest as SendTestRequestOriginal,
  PlaceholderContent as PlaceholderContentOriginal,
  PlaceholderContentValueOneOf as PlaceholderContentValueOneOfOriginal,
  PlainText as PlainTextOriginal,
  Html as HtmlOriginal,
  Money as MoneyOriginal,
  DateTime as DateTimeOriginal,
  Map as MapOriginal,
  _Array as _ArrayOriginal,
  PlaceholderContentEnum as PlaceholderContentEnumOriginal,
  Attachment as AttachmentOriginal,
  Integer as IntegerOriginal,
  Decimal as DecimalOriginal,
  LocalDate as LocalDateOriginal,
  SendTestResponse as SendTestResponseOriginal,
  PauseSchedulingRequest as PauseSchedulingRequestOriginal,
  PauseSchedulingResponse as PauseSchedulingResponseOriginal,
  Paused as PausedOriginal,
  RescheduleRequest as RescheduleRequestOriginal,
  RescheduleResponse as RescheduleResponseOriginal,
  ArchiveCampaignRequest as ArchiveCampaignRequestOriginal,
  ArchiveCampaignResponse as ArchiveCampaignResponseOriginal,
  Archived as ArchivedOriginal,
  UnarchiveCampaignRequest as UnarchiveCampaignRequestOriginal,
  UnarchiveCampaignResponse as UnarchiveCampaignResponseOriginal,
  Unarchived as UnarchivedOriginal,
  UpdateTitleRequest as UpdateTitleRequestOriginal,
  UpdateTitleResponse as UpdateTitleResponseOriginal,
  DeleteCampaignRequest as DeleteCampaignRequestOriginal,
  DeleteCampaignResponse as DeleteCampaignResponseOriginal,
  ReuseCampaignRequest as ReuseCampaignRequestOriginal,
  ReuseCampaignResponse as ReuseCampaignResponseOriginal,
  PreviewCampaignRequest as PreviewCampaignRequestOriginal,
  PreviewCampaignResponse as PreviewCampaignResponseOriginal,
  GetComposerRequest as GetComposerRequestOriginal,
  GetComposerResponse as GetComposerResponseOriginal,
  Composer as ComposerOriginal,
  DefaultValues as DefaultValuesOriginal,
  UpdateComposerRequest as UpdateComposerRequestOriginal,
  UpdateComposerResponse as UpdateComposerResponseOriginal,
  CreateCampaignRequest as CreateCampaignRequestOriginal,
  CreateCampaignResponse as CreateCampaignResponseOriginal,
  ResendToNonOpenersRequest as ResendToNonOpenersRequestOriginal,
  ResendToNonOpenersResponse as ResendToNonOpenersResponseOriginal,
  GetAudienceRequest as GetAudienceRequestOriginal,
  GetAudienceResponse as GetAudienceResponseOriginal,
  CampaignAudience as CampaignAudienceOriginal,
  IdentifySenderAddressRequest as IdentifySenderAddressRequestOriginal,
  IdentifySenderAddressResponse as IdentifySenderAddressResponseOriginal,
  CopyUserTemplateToSiteRequest as CopyUserTemplateToSiteRequestOriginal,
  CopyUserTemplateToSiteResponse as CopyUserTemplateToSiteResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  EstimateFilterSizeRequest as EstimateFilterSizeRequestOriginal,
  EstimateFilterSizeResponse as EstimateFilterSizeResponseOriginal,
  EstimateAudienceSizeRequest as EstimateAudienceSizeRequestOriginal,
  EstimateAudienceSizeResponse as EstimateAudienceSizeResponseOriginal,
  ReconcileContactRequest as ReconcileContactRequestOriginal,
  ReconcileContactResponse as ReconcileContactResponseOriginal,
  Contact as ContactOriginal,
  SearchContactsRequest as SearchContactsRequestOriginal,
  SearchContactsResponse as SearchContactsResponseOriginal,
  GetLabelsRequest as GetLabelsRequestOriginal,
  GetLabelsResponse as GetLabelsResponseOriginal,
  Label as LabelOriginal,
  SubscribeFromLandingPageRequest as SubscribeFromLandingPageRequestOriginal,
  SubscribeFromLandingPageResponse as SubscribeFromLandingPageResponseOriginal,
  ValidateLinkRequest as ValidateLinkRequestOriginal,
  ValidateLinkResponse as ValidateLinkResponseOriginal,
  ValidateHtmlLinksRequest as ValidateHtmlLinksRequestOriginal,
  ValidateHtmlLinksResponse as ValidateHtmlLinksResponseOriginal,
  GetCampaignMappingRequest as GetCampaignMappingRequestOriginal,
  GetCampaignMappingResponse as GetCampaignMappingResponseOriginal,
  UpsertTranslationRequest as UpsertTranslationRequestOriginal,
  UpsertTranslationResponse as UpsertTranslationResponseOriginal,
  GetUsedPlaceholderKeysRequest as GetUsedPlaceholderKeysRequestOriginal,
  GetUsedPlaceholderKeysResponse as GetUsedPlaceholderKeysResponseOriginal,
  LookupCampaignMappingRequest as LookupCampaignMappingRequestOriginal,
  LookupCampaignMappingResponse as LookupCampaignMappingResponseOriginal,
  UpsertAutomationTranslatorContentRequest as UpsertAutomationTranslatorContentRequestOriginal,
  AutomationTranslatorContent as AutomationTranslatorContentOriginal,
  UpsertAutomationTranslatorContentResponse as UpsertAutomationTranslatorContentResponseOriginal,
  GetAutomationTranslatorContentRequest as GetAutomationTranslatorContentRequestOriginal,
  GetAutomationTranslatorContentResponse as GetAutomationTranslatorContentResponseOriginal,
  SendTestBulkRequest as SendTestBulkRequestOriginal,
  SendTestBulkResponse as SendTestBulkResponseOriginal,
  ListStatisticsRequest as ListStatisticsRequestOriginal,
  ListStatisticsResponse as ListStatisticsResponseOriginal,
  CampaignStatisticsContainer as CampaignStatisticsContainerOriginal,
  ListRecipientsRequest as ListRecipientsRequestOriginal,
  RecipientsActivityEnum as RecipientsActivityEnumOriginal,
  RecipientsActivityEnumWithLiterals as RecipientsActivityEnumWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  ListRecipientsResponse as ListRecipientsResponseOriginal,
  CampaignRecipientDetails as CampaignRecipientDetailsOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  PublishApplicationErrors as PublishApplicationErrorsOriginal,
} from './email-marketing-v1-campaign-campaigns.types.js';
